function giftWithPurchaseMakePairId() {
  return `gp_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 11)}`;
}

function giftWithPurchaseAvailableGifts(entry) {
  const list = entry && Array.isArray(entry.gifts) ? entry.gifts : [];
  const seen = new Set();
  return list.filter((gift) => {
    if (!gift || !gift.giftVariantId || gift.giftAvailable === false) return false;
    const id = String(gift.giftVariantId);
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}

function giftWithPurchaseGetEntry(sectionId, variantId) {
  if (!variantId) return null;
  const key = String(variantId);
  let entry = null;
  const mapEl = document.getElementById(`GiftWithPurchaseMap-${sectionId}`);
  if (mapEl && mapEl.textContent) {
    try {
      const map = JSON.parse(mapEl.textContent.trim());
      entry = map[key] || null;
    } catch (e) {
      entry = null;
    }
  }
  if (!entry && typeof window.getGiftWithPurchaseEntry === 'function') {
    entry = window.getGiftWithPurchaseEntry(sectionId, variantId);
  }
  const gifts = giftWithPurchaseAvailableGifts(entry);
  if (!gifts.length) return null;
  return { gifts };
}

function giftWithPurchaseAppendMainProperties(formData, sectionId) {
  const vid = formData.get('id');
  const gift = giftWithPurchaseGetEntry(sectionId, vid);
  if (!gift || !gift.gifts.length) return null;
  const pairId = giftWithPurchaseMakePairId();
  formData.append('properties[_gp_pair]', pairId);
  formData.append('properties[_gp_role]', 'main');
  return { pairId, gifts: gift.gifts };
}

async function giftWithPurchaseAddGiftLine(pairCtx, quantity, sections, pathname) {
  if (!pairCtx) return null;
  const { pairId, gift } = pairCtx;
  const fd = new FormData();
  fd.append('id', String(gift.giftVariantId));
  fd.append('quantity', String(quantity || 1));
  fd.append('properties[_gp_pair]', pairId);
  fd.append('properties[_gp_role]', 'gift');
  if (sections && sections.length > 0) {
    fd.append('sections', [...new Set(sections)]);
    fd.append('sections_url', pathname || window.location.pathname);
  }
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = fd;
  return fetch(`${routes.cart_add_url}`, config).then((res) => res.json());
}

function giftWithPurchaseCollectPropertiesFromFormData(formData) {
  const props = {};
  formData.forEach((value, key) => {
    const m = key.match(/^properties\[(.+)\]$/);
    if (m) props[m[1]] = value;
  });
  return props;
}

function giftWithPurchaseBuildBulkAddPayload(formData, giftCtx, sections, pathname) {
  const qty = parseInt(String(formData.get('quantity') || '1'), 10) || 1;
  const mainVid = parseInt(String(formData.get('id')), 10);
  const { pairId, gifts } = giftCtx;
  const mainProps = giftWithPurchaseCollectPropertiesFromFormData(formData);
  const items = [{ id: mainVid, quantity: qty, properties: mainProps }];
  (gifts || []).forEach((gift) => {
    const giftVid = parseInt(String(gift.giftVariantId), 10);
    if (!giftVid) return;
    items.push({
      id: giftVid,
      quantity: qty,
      properties: { _gp_pair: pairId, _gp_role: 'gift' },
    });
  });
  const sellingPlan = formData.get('selling_plan');
  if (sellingPlan) {
    const sp = parseInt(String(sellingPlan), 10);
    if (!Number.isNaN(sp)) items[0].selling_plan = sp;
  }
  const payload = { items };
  if (sections && sections.length > 0) {
    payload.sections = [...new Set(sections)];
    payload.sections_url = pathname || window.location.pathname;
  }
  return payload;
}

function giftWithPurchaseAddMainAndGiftBulkJson(formData, giftCtx, sections, pathname) {
  const payload = giftWithPurchaseBuildBulkAddPayload(formData, giftCtx, sections, pathname);
  return fetch(`${routes.cart_add_url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  }).then((res) =>
    res.json().then((json) => {
      if (!res.ok || json.status) return Promise.reject(new Error('bulk add failed'));
      return json;
    })
  );
}

async function giftWithPurchaseLegacyTwoStepAdd(formData, giftCtx, sections, pathname) {
  const mainCfg = fetchConfig('javascript');
  mainCfg.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete mainCfg.headers['Content-Type'];
  mainCfg.body = formData;
  const mainRes = await fetch(`${routes.cart_add_url}`, mainCfg).then((r) => r.json());
  if (mainRes.status) return mainRes;
  const gifts = giftCtx.gifts || [];
  let last = mainRes;
  for (let i = 0; i < gifts.length; i++) {
    const giftRes = await giftWithPurchaseAddGiftLine(
      { pairId: giftCtx.pairId, gift: gifts[i] },
      formData.get('quantity'),
      sections,
      pathname
    );
    if (giftRes && !giftRes.status) last = giftRes;
  }
  return last;
}

function giftWithPurchaseAddMainThenMaybeGift(formData, giftCtx, sections, pathname) {
  return giftWithPurchaseAddMainAndGiftBulkJson(formData, giftCtx, sections, pathname).catch(() =>
    giftWithPurchaseLegacyTwoStepAdd(formData, giftCtx, sections, pathname)
  );
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.checkoutInProgress = false;
      this.addEventListener('click', this.onMorePaymentClick.bind(this), true);
    }

    onMorePaymentClick(event) {
      const more = event.target.closest('.shopify-payment-button__more-options');
      if (!more || !this.contains(more)) return;
      event.preventDefault();
      event.stopPropagation();
      this.checkoutWithAccessories();
    }

    async checkoutWithAccessories() {
      if (this.checkoutInProgress || !this.form) return;
      this.checkoutInProgress = true;

      const formData = new FormData(this.form);
      const giftCtx = giftWithPurchaseAppendMainProperties(formData, this.dataset.source);
      let selectedAccessories = [];
      try {
        selectedAccessories = this.form.dataset.selectedAccessories
          ? JSON.parse(this.form.dataset.selectedAccessories)
          : [];
      } catch (error) {
        selectedAccessories = [];
      }
      if (!Array.isArray(selectedAccessories)) selectedAccessories = [];

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      try {
        const response = giftCtx
          ? await giftWithPurchaseAddMainThenMaybeGift(formData, giftCtx, [], window.location.pathname)
          : await fetch(`${routes.cart_add_url}`, config).then((res) => res.json());

        if (response.status) {
          this.handleErrorMessage(response.description);
          this.checkoutInProgress = false;
          return;
        }

        if (selectedAccessories.length > 0) {
          await this.addSelectedAccessories(selectedAccessories, []);
        }

        const checkoutForm = document.createElement('form');
        checkoutForm.method = 'POST';
        checkoutForm.action = routes.cart_url;
        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutForm.appendChild(checkoutInput);
        document.body.appendChild(checkoutForm);
        checkoutForm.submit();
      } catch (error) {
        console.error(error);
        this.handleErrorMessage('Failed to add items to cart. Please try again.');
        this.checkoutInProgress = false;
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      const giftCtx = giftWithPurchaseAppendMainProperties(formData, this.dataset.source);
      let selectedAccessories = [];
      try {
        selectedAccessories = this.form && this.form.dataset.selectedAccessories
          ? JSON.parse(this.form.dataset.selectedAccessories)
          : [];
      } catch (error) {
        selectedAccessories = [];
      }
      if (!Array.isArray(selectedAccessories)) selectedAccessories = [];

      let sections = [];
      const holdSections = Boolean(giftCtx) || selectedAccessories.length > 0;
      if (this.cart) {
        sections = this.cart.getSectionsToRender().map((section) => section.id);
        if (!holdSections) {
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
        }
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      let addRequest;
      try {
        addRequest = giftCtx
          ? giftWithPurchaseAddMainThenMaybeGift(
              formData,
              giftCtx,
              selectedAccessories.length > 0 ? [] : sections,
              window.location.pathname
            )
          : fetch(`${routes.cart_add_url}`, config).then((response) => response.json());
      } catch (error) {
        console.error(error);
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        return;
      }

      addRequest
        .then(async (response) => {
          // CART ERROR EVENT
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: this.dataset.source,
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message
                }
              })
            );
            // -------------------------------------------
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          let finalResponse = response;
          if (selectedAccessories.length > 0) {
            const accessoryResponse = await this.addSelectedAccessories(selectedAccessories, sections);
            if (accessoryResponse) finalResponse = accessoryResponse;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // VARIANT ADDED EVENT
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source
              }
            })
          );
          // -------------------------------------------

          fetch(`${routes.cart_url}.js`)
            .then((response) => {
              return response.text()
            })
            .then((state) => {
              const parsedState = JSON.parse(state)

              // dispatch cart:change for the entire basket
              document.dispatchEvent(
                new CustomEvent('cart:change', {
                  detail: {
                    cart: parsedState,
                    sectionId: this.dataset.source,
                  },
                })
              )
              // dispatch cart:change for the entire basket

            })
            .catch((error) => {
              console.error('Error fetching cart state:', error);
            })

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') })
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(finalResponse) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(finalResponse);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    async addSelectedAccessories(selectedAccessories, sections) {
      let finalResponse = null;
      for (let i = 0; i < selectedAccessories.length; i++) {
        const accessory = selectedAccessories[i];
        const accessoryVariantId = accessory && (accessory.variantId || accessory);
        const accessoryQuantity = (accessory && accessory.quantity) || 1;
        if (!accessoryVariantId) continue;

        const accessoryFormData = new FormData();
        accessoryFormData.append('id', String(accessoryVariantId));
        accessoryFormData.append('quantity', String(accessoryQuantity));
        if (i === selectedAccessories.length - 1 && sections.length > 0) {
          accessoryFormData.append('sections', sections);
          accessoryFormData.append('sections_url', window.location.pathname);
        }

        const accessoryConfig = fetchConfig('javascript');
        accessoryConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete accessoryConfig.headers['Content-Type'];
        accessoryConfig.body = accessoryFormData;

        try {
          const accessoryResponse = await fetch(`${routes.cart_add_url}`, accessoryConfig).then((res) => res.json());
          if (accessoryResponse && !accessoryResponse.status) finalResponse = accessoryResponse;
        } catch (error) {
          console.error(error);
        }
      }

      if (finalResponse && finalResponse.sections) return finalResponse;
      if (!sections.length) return finalResponse;

      try {
        const data = await fetch(`${window.location.pathname}?sections=${sections.join(',')}`).then((res) => res.json());
        return { sections: data, id: finalResponse && finalResponse.id };
      } catch (error) {
        console.error(error);
        return finalResponse;
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
